import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component'; 
import { NavMenuComponentTech } from './nav-menu/nav-menu-tech.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { TechnologyComponent } from './technology/technology.component';
import { EditorialComponent } from './editorial/editorial.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { AboutComponent } from './about/about.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientDetailsComponent } from "./clients/client-details/clientDetails.component";
import { TechClientsComponent } from './tech-clients/tech-clients.component';
import { EditorialClientsComponent } from './editorial-clients/editorial-clients.component';
import { HelloWorldComponent } from './hello-world/hello-world.component';
import { FooterComponent } from './footer/footer.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    NavMenuComponentTech,
    HomeComponent,
    CounterComponent,
    AboutComponent,
    TechnologyComponent,
    FetchDataComponent,
    ClientsComponent,
    ClientDetailsComponent,
    EditorialComponent,
    TechClientsComponent,
    EditorialClientsComponent,
    HelloWorldComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'about', component: AboutComponent },
      { path: 'technology', component: TechnologyComponent },
      { path: 'editorial', component: EditorialComponent },
      { path: 'clients', component: ClientsComponent },
      { path: 'clients/:id', component: ClientDetailsComponent },
      { path: 'tech-clients', component: TechClientsComponent },
      { path: 'editorial-clients', component: EditorialClientsComponent },
      { path: 'hello-world', component: HelloWorldComponent }
    ])
    , NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
